<template lang="pug">
v-card.mb-3
  v-card-title.title.grey.lighten-4 {{extra && extra.name || 'Projekte Status'}}
  v-card-text
    template(v-if="!user")
      | Bitte anmelden
    template(v-if="!isTicketer")
    template(v-else)
      template(v-for="kundenProjekte, kunde in kunden")
        .title {{kunde}}
        v-layout(wrap)
          v-flex(xs12)
            v-data-table(:items="kundenProjekte" :headers="projekteHeader" must-sort :pagination.sync="projektePagination")
              template(v-slot:items="{ item }")
                td {{ item.namePnr }}
                td {{ item.standort && item.standort.aussenstelle }}
                td {{ item.standort && item.standort.ip }}
                td {{ item.subnetz }}
                td {{ item.publicIp }}
                td
                  .success--text(v-if="item.vpnStatus") Online
                  .error--text(v-else-if="item.vpnStatus === false") Offline
                  .grey--text(v-else) Unbekannt
                td.white--text(:style="`background-color: ${item.bgColor}`") {{ item.abteilung }}
                td: v-btn(@click="qrcodeAs = false; qrcodeProjekt = item") QR Projekt
                td: v-btn(@click="qrcodeAs = true; qrcodeProjekt = item") QR AS
  v-dialog(:value="!!qrcodeProjekt" @input="qrcodeProjekt = null" max-width="500")
    v-card
      v-card-title.title.grey.lighten-3(v-if="!qrcode") Nicht vorhanden
      v-card-text(v-if="qrcode" style="text-align: center")
        div(style="display: inline-block")
          hvd-qrcode(:input="qrcode" :text="qrcodeText")

</template>

<script>
import gql from 'graphql-tag'
import { groupBy } from 'lodash'

export default {
  props: ['extra'],
  data() {
    return {
      user: null,
      qrcodeProjekt: null,
      qrcodeAs: false,
      projektePagination: {
        descending: true,
        rowsPerPage: 100,
        sortBy: 'abteilung'
      },
      projekteHeader: [
        { text: 'Name', value: 'namePnr' },
        { text: 'AS', value: 'standort.aussenstelle' },
        { text: 'Adrressraum', value: 'standort.ip' },
        { text: '', value: 'subnetz' },
        { text: 'IP', value: 'publicIp' },
        { text: 'VPN', value: 'vpnStatus' },
        { text: 'Abteilung', value: 'abteilung' },
        { text: ' ', sortable: false },
      ],
    }
  },
  apollo: {
    projekte: {
      query: gql`query ExtraProjekteStatus {
        projekte {
          id
          namePnr
          abteilung
          bgColor
          pnr
          vpnStatus
          publicIp
          subnetz
          standort {
            aussenstelle
            ip
            itKunde {
              id
              firma
            }
          }
        }
      }`,
    },
    user: {
      query: gql`query ExtraProjekteStatusUser {
        user: currentUser {
          id
          person {
            id
            ticketBearbeiter
          }
        }
      }`,
    }
  },
  computed: {
    isTicketer() {
      return this.user && this.user.person && this.user.person.ticketBearbeiter
    },
    qrcode() {
      const projekt = this.qrcodeProjekt
      if (!projekt) {
        return
      }
      if (this.qrcodeAs && projekt.standort && projekt.standort.aussenstelle) {
        return `https://box.hvd-bb.de/as/${projekt.standort.aussenstelle.replace(/^(HVD-|AS-)*/i, '')}`
      } else if (!this.qrcodeAs && projekt.pnr) {
        return `https://box.hvd-bb.de/p/${projekt.pnr}`
      }
    },
    qrcodeText() {
      const projekt = this.qrcodeProjekt
      if (!projekt) {
        return
      }
      if (this.qrcodeAs && projekt.standort && projekt.standort.aussenstelle) {
        return projekt.standort.aussenstelle
      } else if (!this.qrcodeAs && projekt.pnr) {
        return `P${projekt.pnr}`
      }
    },
    kunden() {
      return groupBy(this.projekte || [], (p) => p.standort && p.standort.itKunde && p.standort.itKunde.firma || '')
    },
  },
}
</script>
